import React from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import SelectField from '../../../../Components/Form/components/SelectField';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import moment from 'moment';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import useTranslation from '../../../../Hooks/useTranslation';
import { useCreateInsuranceReportExportFilesMutation } from '../../../../graphql/graphql';
import useNotification from '../../../../Hooks/useNotification.hook';

interface Props {
	insuranceCompanyCode: string;
	rootWorkplaceId: string;
	onSuccess: () => void;
}

const months: SelectValue[] = [
	{ value: 1, label: 'base.months.january' },
	{ value: 2, label: 'base.months.february' },
	{ value: 3, label: 'base.months.march' },
	{ value: 4, label: 'base.months.april' },
	{ value: 5, label: 'base.months.may' },
	{ value: 6, label: 'base.months.june' },
	{ value: 7, label: 'base.months.july' },
	{ value: 8, label: 'base.months.august' },
	{ value: 9, label: 'base.months.september' },
	{ value: 10, label: 'base.months.october' },
	{ value: 11, label: 'base.months.november' },
	{ value: 12, label: 'base.months.december' },
];

const startYear = moment().year();
const endYear = 2024;

const years = Array.from({ length: startYear - endYear + 1 }, (_, i) => ({
	value: startYear - i,
	label: (startYear - i).toString(),
}));

const InsuranceCompanyInsuranceExportGen: React.FC<Props> = ({
	insuranceCompanyCode,
	rootWorkplaceId,
	onSuccess,
}) => {
	const [createInsuranceReportExport] =
		useCreateInsuranceReportExportFilesMutation();
	const { t } = useTranslation();
	const { showNotificationSuccess } = useNotification();
	const validationSchema = yup.object({});

	const translatesMonths = months.map(item => {
		return { value: item.value, label: t(item.label) };
	});

	const formMethods = useForm({
		defaultValues: {
			month: translatesMonths.find(item => item.value === moment().month() + 1),
			year: years.find(item => item.value === moment().year()),
		},
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = async (values: any) => {
		const result = await createInsuranceReportExport({
			input: {
				rootWorkplaceId,
				insuranceCompanyCode,
				month: values.month.value,
				year: values.year.value,
			},
		});

		if ('data' in result) {
			showNotificationSuccess({
				content: t(
					'component.insuranceCompanyInsuranceExportGen.successMessage',
				),
			});
			onSuccess();
		}
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<div className='row'>
				<div className='col-8'>
					<SelectField name='month' options={translatesMonths} portal />
				</div>
				<div className='col-4'>
					<SelectField name='year' options={years} portal />
				</div>
			</div>
			<div className='mt-3'>
				<SubmitButton
					onSubmit={handleSubmit}
					title='component.insuranceCompanyInsuranceExportGen.submitButton'
				/>
			</div>
		</FormWrapper>
	);
};

export default InsuranceCompanyInsuranceExportGen;
